import React from "reactn";

export const getGrupoPorIdDePresentacion = (gruposPresentaciones, presentacionId) => {
    const grupoPresentacion = gruposPresentaciones?.find(grupo => grupo.presentaciones_refs?.includes(presentacionId));
    return grupoPresentacion;
}
export const hayDatosGrupoPresentacion = (grupoPresentacion, presentacionId = "") => grupoPresentacion?.presentaciones_refs?.includes(presentacionId);